import { render, staticRenderFns } from "./ProcessesLayout.vue?vue&type=template&id=3b0e4414&scoped=true&"
import script from "./ProcessesLayout.vue?vue&type=script&lang=js&"
export * from "./ProcessesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0e4414",
  null
  
)

export default component.exports